import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'menu-span-item',
  styleUrl: 'menu-span-item.scss',
})
export class MenuItem {
  @Prop() click_section?: string;
  @Prop() click_link?: string;
  @Prop() styles: string;
  @Prop() href: string;

  render() {
    return (
      <li class="ghf-menu-listItem">
        <span class={`${this.styles != undefined ? this.styles : ''} js-menu-span-link js-ciHeader-track ghf-menu-link`}
        data-href={this.href && this.href}
        data-section={`${this.click_section}`}
        data-link={`${this.click_link}`}>
          <slot></slot>
        </span>
      </li>
    );
  }
}
